import meta from '#utilities/js/ea/meta.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const caseDateFormat = object(null, {
  DMY: (day, month, year) => {
    return `${day}/${month}/${year}`
  },
  MDY: (day, month, year) => {
    return `${month}/${day}/${year}`
  },
  YMD: (day, month, year) => {
    return `${year}/${month}/${day}`
  },
})

export const dateUserFormat = (
  ownerDocument,
  day
) => {
  const { documentElement } = ownerDocument
  const { lang } = documentElement
  const metaDateFormat = one(`meta[name="ea_s_date"]`, ownerDocument)
  const [dateFormat] = metaDateFormat ? meta('s_date') : ['DMY']
  const dateDay = new Date(day * 24 * 60 * 60 * 1000)
  const dayDigit = new Intl.DateTimeFormat(lang, {
    day: '2-digit',
    timeZone: 'GMT'
  }).format(dateDay)
  const monthDigit = new Intl.DateTimeFormat(lang, {
    month: '2-digit',
    timeZone: 'GMT'
  }).format(dateDay)
  const yearDigit = new Intl.DateTimeFormat(lang, {
    year: 'numeric',
    timeZone: 'GMT'
  }).format(dateDay)

  return caseDateFormat[dateFormat]?.(dayDigit, monthDigit, yearDigit)
}

export const timeUserFormat = (
  ownerDocument,
  sec
) => {
  if (sec >= 86400) {
    return
  }
  
  const metaTimeFormat = one(`meta[name="ea_s_date_hour"]`, ownerDocument)
  const [timeFormat] = metaTimeFormat ? meta('s_date_hour') : ['24']
  const hours = Math.floor(sec / 3600)
  const minutes = Math.floor((sec % 3600) / 60)
  let formatHours = hours
  let antePost = ''

  if (timeFormat === '12') {
    antePost = hours >= 12 ? ' PM' : ' AM'
    formatHours = hours % 12
    if (formatHours === 0) {
      formatHours = 12
    }
  }

  const formatHoursStr = formatHours.toString().padStart(2, '0')
  const formatMinutesStr = minutes.toString().padStart(2, '0')

  return formatHoursStr + ':' + formatMinutesStr + antePost
}
